// CPM is mandatory in the New Query form but optional in the FQS API, so the
// rule lives here (the form) and not in the request layer.

const CPM_PATTERN = /^(\d+\.?\d*|\.\d+)$/;

// Keystroke filter for the input: digits and at most one decimal point.
export const isCpmInput = (raw: string): boolean => /^\d*\.?\d*$/.test(raw);

export const validateCpm = (
  raw: string,
): { value: number | null; error: string } => {
  const text = (raw ?? "").trim();
  if (!text) return { value: null, error: "CPM is required." };
  const value = Number(text);
  if (!CPM_PATTERN.test(text) || !Number.isFinite(value) || value <= 0) {
    return { value: null, error: "CPM must be a number greater than zero." };
  }
  return { value, error: "" };
};
